import axios from "axios";
import { getCookies, deleteCookies } from "./utils";
import { toast } from "react-toastify";
import eventEmitter from "../events/eventEmitter";

export const apiURL = process.env.REACT_APP_API_URL;

let store; // <-- to hold Redux store reference

export const injectStore = (_store) => {
  store = _store;
};

console.log(apiURL, "apiURL");
export const recaptchaKey = "";

export const api = axios.create({
  baseURL: apiURL,
});

api.defaults.headers = {
  "Access-Control-Allow-Origin": `*`,
  "Access-Control-Allow-Methods": "GET,POST,PUT,DELETE,PATCH,OPTIONS",
  "Content-Type": "application/json; charset=utf-8",
  Accept: "*/*",
};

api.interceptors.request.use(
  function (config) {
    const token = getCookies("xcasino_token");

    if (store) {
      const state = store.getState();
      // const location = state?.location?.locationData; // adjust this to your slice path
      const deviceInfo = state?.device?.deviceInfo;
      console.log(deviceInfo, "+++++++++++++");
      // if (location) {
      //   config.headers["X-User-Location"] = JSON.stringify(location);
      // }
      if (deviceInfo) {
        config.headers["User-Device-Info"] = JSON.stringify(deviceInfo);
      }
    }

    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// api.interceptors.request.use(
//   function (config) {
//     config.headers.Authorization = `Bearer ${getCookies("xcasino_token")}`;
//     // config.headers["Content-Type"] = "application/json; charset=utf-8"
//     return config;
//   },
//   function (error) {
//     return Promise.reject(error);
//   }
// );

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const status = error?.response?.status;
    const message = error?.response?.data?.message;

    if (status === 401) {
      console.log("Your session has expired. Please log in again.");
      deleteCookies("xcasino_token");

      setTimeout(() => {
        window.location.href = "/signin-username";
      }, 1000);
    } else if (status === 400) {
      if (message === "Missing user location header.") {
        // alert("Please enable location access to continue.");
        eventEmitter.emit("missingLocation");
      } else {
        toast.error(message || "Bad Request");
      }
    } // Handle 403 errors - all emit with message
    else if (status === 403) {
      eventEmitter.emit("locationBlocked", message);
    } else if (status === 404) {
      // toast.error(error.response.data?.error || "Not Found");
    }

    return Promise.reject(error);
  }
);

// api.interceptors.response.use(
//   (response) => {
//     console.log("error", response)
//     if (response?.status === 401) {
//       deleteCookies("xcasino_token");
//       setTimeout(() => {
//         window.location.href = "/signin";
//       }, 1500);
//     }
//     return response;
//   },
//   function (error) {

//     console.log("error 44", error.response)
//     if (error?.response?.data.code === 401) {
//       setTimeout(() => {
//         window.location.href = "/signin";
//       }, 1500);
//        return Promise.reject(error);
//     } else if(error.response.data.code == 400) {
//       toast.error(error.response.data.message)
//     } else if(error.response.status == 404) {
//       toast.error(error.response.data.error)
//     }
//      return Promise.reject(error);
//   }
// );

export default api;
